import React from "react";
import { Link } from "react-router-dom";

const PostListItems = ({ post }) => {
  const {
    id,
    title,
    author,
    thumbnail,
    url,
    created_utc,
    num_comments,
    subreddit,
  } = post.data;

  const getUtcTime = (utcHours) => {
    let currentTime = Date.now() / 1000;
    let timeHour = (currentTime - utcHours) / 60 / 60;
    let timePassed;

    if (timeHour < 24) timePassed = Math.floor(timeHour) + " h ago";
    else timePassed = Math.floor(timeHour / 24) + "d ago";
    return timePassed;
  };

  return (
    <div className="post-list-item-child">
      <h3>{title}</h3>

      {thumbnail === "" || thumbnail === "self" ? (
        <div></div>
      ) : (
        <div>
          <img className="post-list-item-child-img" src={url} alt="" />
        </div>
      )}

      <div className="itemDetail">
        <p className="author child">{author}</p>

        <p className="centerItem child ">{getUtcTime(created_utc)}</p>

        <div className="rightItem child">
          <Link to={`/r/${subreddit}/comments/${id}/`}>
            <button className="itemDetailButton">
              <img src="commentLogo.jpg" alt="Comment" />
              Comments
            </button>
          </Link>
          <p className="comment child">{num_comments}</p>
        </div>
      </div>
    </div>
  );
};

export default PostListItems;
